import { ImageBackground, Pressable, Image } from 'react-native'
import { useLocation, useNavigate } from 'react-router-dom'
import useScrollTp from '../hooks/use-scroll-top'
import useDimension from '../hooks/use-dimension'
import PageWrapper from './PageWrapper'
// import { btnBack, btnBack2, btnHint } from '../data/images'
import { imgCommons } from '../data/images'
import { useState } from 'react'
import { useAudio } from '../context/AudioContext'
const { btnBack, btnHint } = imgCommons

type Props = {
  children: React.ReactNode
  src: string
  alt: string
  btns?: {
    back?: { img: 0 | 1; onBack?: () => void }
    hint?: { id: number; page: number }
  }
  styles?: React.CSSProperties
  noMusic?: boolean
}
const { musicOff, musicOn } = imgCommons

export default function PageBg({
  children,
  src,
  alt,
  btns = {},
  styles,
  noMusic,
}: Props) {
  useScrollTp()

  const { ws } = useDimension()
  const navigate = useNavigate()
  const location = useLocation()
  const { toggleAudio, isPlaying } = useAudio()

  const [musicIcon, setMusicIcon] = useState(
    isPlaying ? musicOn : musicOff,
  )

  const onMenu = () => navigate('/main', { replace: true })
  const onBack = btns.back?.img ? onMenu : () => navigate(-1)
  const onHint = () =>
    btns.hint
      ? navigate(`/stage/hints`, {
          state: {
            id: btns.hint.id,
            page: btns.hint.page ?? 0,
            prev: location.pathname,
          },
        })
      : () => {}

  const toggleMusic = () => {
    if (isPlaying) {
      toggleAudio()
      setMusicIcon(musicOff)
    } else {
      toggleAudio()
      setMusicIcon(musicOn)
    }
  }

  return (
    <PageWrapper
      style={{
        width: 360 * ws,
        maxHeight: 640 * ws,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        ...styles,
      }}
    >
      {!noMusic && (
        <Pressable
          onPress={toggleMusic}
          style={{
            width: 46 * ws,
            height: 46 * ws,
            position: 'absolute',
            top: 30 * ws,
            left: 290 * ws,
            zIndex: 1,
          }}
        >
          <Image
            source={{ uri: musicIcon }}
            style={{ width: '100%', height: '100%' }}
          />
        </Pressable>
      )}

      <ImageBackground
        source={{ uri: src }}
        style={{
          width: 360 * ws,
          height: 640 * ws,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        resizeMode="cover"
        aria-label={alt}
      >
        {children}

        {btns.back && (
          <Pressable
            style={{
              position: 'absolute',
              top: 70 * ws,
              left: 0,
              zIndex: 1,
            }}
            onPress={onBack}
          >
            <Image
              source={{ uri: btnBack }}
              resizeMode="contain"
              style={{
                width: 72.5 * ws,
                height: 30.5 * ws,
                alignSelf: 'center',
              }}
              aria-label={`btn-back`}
            />
          </Pressable>
        )}

        {btns.hint && (
          <Pressable
            style={{
              position: 'absolute',
              top: 70 * ws,
              right: 6.5 * ws,
              zIndex: 1,
            }}
            onPress={onHint}
          >
            <Image
              source={{ uri: btnHint }}
              resizeMode="contain"
              style={{
                width: 80 * ws,
                height: 40 * ws,
                alignSelf: 'center',
              }}
              aria-label={`btn-hint`}
            />
          </Pressable>
        )}
      </ImageBackground>
    </PageWrapper>
  )
}
